import { Box, CircularProgress } from '@material-ui/core';
import { SWRConfig } from 'swr';

import { AddWebhookDialog } from '@/components/modules/Webhooks/components/dialogs/AddWebhookDialog';
import { WebhooksTable } from '@/components/modules/Webhooks/components/WebhooksTable/WebhooksTable';
import { useWebhooks } from '@/components/modules/Webhooks/hooks/useWebhooks';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { PendingDataType } from '@/config/types';

interface WebhooksListProps {
  userId: string;
  editModeAllowed?: boolean;
}

export const WebhooksList = ({ userId, editModeAllowed = true }: WebhooksListProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const { webhooks, loadingWebhooks } = useWebhooks(userId);

  const specificActionsOptionsArray: ActionsOption[] | undefined = editModeAllowed
    ? [
        {
          display: <Text tId={'CREATE_NEW_WEBHOOK'} />,
          onClick: toggleDialog,
          iconName: 'add',
        },
      ]
    : undefined;

  return (
    <SubSectionWrapper title={'WEBHOOKS_LIST'} specificActionsOptionsArray={specificActionsOptionsArray}>
      <SWRConfig value={{ revalidateOnMount: false }}>
        {webhooks && webhooks.length > 0 ? (
          <WebhooksTable userId={userId} webhooks={webhooks} />
        ) : loadingWebhooks ? (
          <Box display={'flex'} justifyContent={'center'}>
            <CircularProgress color={'secondary'} size={24} style={{ margin: '20px 0' }} />
          </Box>
        ) : (
          <PendingDataWarning type={PendingDataType.NO_WEBHOOK_CONFIGURED} />
        )}
        {opened && (
          <AddWebhookDialog opened={opened} setOpened={setOpened} toggleDialog={toggleDialog} userId={userId} />
        )}
      </SWRConfig>
    </SubSectionWrapper>
  );
};
